import { AmplitudeEvent } from "@/telemetry/AmplitudeEvent";
import OutcomeType from "@/constants/OutcomeType";

export class TopicOutcomeCompletedEvent extends AmplitudeEvent {
	constructor( meetingId ) {
		super();
		this.name = "Topic Outcome Completed";
		this.eventProperties.meeting_id = meetingId;
		// NOTE: only commitments may be completed
		this.eventProperties.outcome_type = OutcomeType.COMMITMENT;
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/TopicOutcomeCompletedEvent.js